import { create } from "zustand";
import userApi from "../services/api/userApi";

const useWidget = create((set, get) => ({
  installToken: "",
  colors: {
    header: "",
    headerText: "",
    button: "",
    buttonText: "",
    userBg: "",
    userText: "",
    botBg: "",
    botText: "",
  },

  setInstallToken: (installToken) => {
    set({ installToken });
    get().saveWidgetToAPI();
  },

  setColors: (colors) => {
    set({ colors });
    get().saveWidgetToAPI();
  },


  loadWidgetFromAPI: async () => {
    try {
      const response = await userApi.workspace();
      if (response.data.frontend.widget) {
        set(response.data.frontend.widget);
      }
    } catch (error) {
      console.error("Erro ao carregar configurações do widget:", error);
    }
  },


  saveWidgetToAPI: async () => {
    try {
      const { installToken, colors } = get();
      await userApi.workspaceUpdate({
        widget: {
          installToken,
          colors,
        },
      });
    } catch (error) {
      console.error("Erro ao salvar configurações do widget:", error);
    }
  },
}));

export default useWidget;
